import { Close as CloseIcon, Sort } from '@mui/icons-material'
import { Box, Chip, IconButton, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BillingFilters } from '../interfaces'

interface Props {
  filters: BillingFilters
  onRemoveFilter: (filter: keyof BillingFilters) => void
  onOpenFiltersModal: () => void
}

const FiltersBar: React.FC<Props> = ({
  filters,
  onRemoveFilter,
  onOpenFiltersModal,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const removeFilterIcon = (
    <CloseIcon
      sx={{
        '&&': {
          color: theme.palette.textOrIcon.onPrimary,
          '&:hover': {
            borderRadius: '50%',
            backgroundColor: theme.palette.cookieBanner.main,
          },
        },
      }}
    />
  )

  return (
    <Box
      m={2}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}
    >
      <Box mx={2}>
        {Object.entries(filters).map(([key, value]) =>
          value.value ? (
            <Chip
              key={key}
              label={value.value}
              onDelete={() => onRemoveFilter(key as keyof BillingFilters)}
              color="primary"
              deleteIcon={removeFilterIcon}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.textOrIcon.onPrimary,
                marginRight: theme.spacing(1),
              }}
            />
          ) : null
        )}
      </Box>
      <Typography
        variant="body1"
        component="span"
        color={theme.palette.textOrIcon.subheader}
      >
        {t('LCDLicensingTable.Filter.Label', 'Filters')}
      </Typography>
      <IconButton aria-label="Filter By" onClick={onOpenFiltersModal}>
        <Sort />
      </IconButton>
    </Box>
  )
}

export default FiltersBar
